export default {
  accept: 'ยอมรับ',
  reject: 'ปฏิเสธ',
  companyHasInvited: '{{companyName}} ได้ส่งคำเชิญให้คุณเข้าร่วมเป็นทีมงาน',
  sentPasswordLinkInEmail: 'อีเมลสำหรับการเปลี่ยนรหัสผ่านใหม่ได้ถูกส่งไปแล้ว <br/><br/> กรุณาเช็คอีเมลของคุณเพื่อตั้งค่ารหัสผ่านใหม่'
};